export default __webpack_public_path__ + "static/media/Boots of the Still Pond.3d59bf69.jpg";